import React from 'react'
import styled, { keyframes, ThemeProvider } from 'styled-components'

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const LoaderStyle = styled.div`
  display: inline-block;
  width: ${props => props.theme.size + props.theme.size * 0.25};
  height: ${props => props.theme.size + props.theme.size * 0.25};

  &:after {
      display: block;
      width: ${props  => props.theme.size};
      height: ${props  => props.theme.size};
      margin:  ${props  => props.theme.size * 0.25};
      border-radius: 50%;
      border: $${props  => props.theme.lineWidth} solid ${props  => props.theme.color};
      border-color: ${props  => props.theme.color} transparent ${props  => props.theme.color} transparent;
      animation: ${spin} 1.2s linear infinite;
  }
`

const Loader = ({ size = '100%', color = '#047ccc', lineWidth = '4px', className }) => {

    return (
      <ThemeProvider theme={{ size, color, lineWidth }}>
        <LoaderStyle className={className} />
      </ThemeProvider>
    )
}

export default Loader